export default __webpack_public_path__ + "static/media/fontRoboto400_cyrillic.71a33b6b.woff2";